(function () {
  function canonicalizeRodentLabProductUrl() {
    var legacyProductPath = "/products/rodentlab-2026-ugc-ab";
    var productPath = "/en/products/rodentlab-2026-ugc-ab";
    var variantId = "45553475190982";
    var targetView = "gb2";
    var targetCurrency = "GBP";

    if (window.location.hostname !== "rodentlab.com") return false;
    var params = new URLSearchParams(window.location.search);

    if (window.location.pathname === legacyProductPath) {
      params.set("variant", variantId);
      params.set("view", targetView);
      params.set("currency", targetCurrency);
      params.delete("rl_ab");
      window.location.replace(productPath + "?" + params.toString() + window.location.hash);
      return true;
    }
    if (window.location.pathname !== productPath) return false;

    var shouldRedirect = false;
    if (params.get("variant") !== variantId) {
      params.set("variant", variantId);
      shouldRedirect = true;
    }
    if (params.get("view") !== targetView) {
      params.set("view", targetView);
      shouldRedirect = true;
    }
    if ((params.get("currency") || "").toUpperCase() !== targetCurrency) {
      params.set("currency", targetCurrency);
      shouldRedirect = true;
    }
    if (params.has("rl_ab")) {
      params.delete("rl_ab");
      shouldRedirect = true;
    }
    if (!shouldRedirect) return false;

    var query = params.toString();
    window.location.replace(productPath + (query ? "?" + query : "") + window.location.hash);
    return true;
  }

  function polishRodentLabUkContent() {
    if (window.location.hostname !== "rodentlab.com") return;
    if (!/\/(?:en\/)?products\/rodentlab-2026-ugc-ab$/.test(window.location.pathname)) return;

    var cleanProductUrl = "/en/products/rodentlab-2026-ugc-ab?view=gb2&variant=45553475190982&currency=GBP";
    document.querySelectorAll('a[href*="rodentlab-2026-ugc-ab"]').forEach(function (link) {
      link.setAttribute("href", cleanProductUrl);
    });

    document.querySelectorAll(".product__title h1").forEach(function (title) {
      if (/RodentLab™.*Pest Repeller/.test(title.textContent)) {
        title.textContent = "RodentLab™ Pest Repeller | UK Home Support";
      }
    });

    document.querySelectorAll(".announcement-bar__message span, .announcement-bar__message").forEach(function (node) {
      if (/Start with the 4-pack for bedroom|4-pack room setup/.test(node.textContent)) {
        node.textContent = "4-pack setup · 90-day guarantee";
      }
    });
  }

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  if (canonicalizeRodentLabProductUrl()) return;
  onReady(polishRodentLabUkContent);
  setTimeout(polishRodentLabUkContent, 800);
  setTimeout(polishRodentLabUkContent, 2000);

  function forceUkLocalization() {
    var targetCountry = "GB";
    var targetCurrency = "GBP";
    var cookie = document.cookie || "";
    var hasTargetCountry = cookie.indexOf("localization=" + targetCountry) !== -1;
    var hasTargetCart = cookie.indexOf("cart_currency=" + targetCurrency) !== -1;

    if (hasTargetCountry && hasTargetCart) return;

    try {
      if (window.sessionStorage && sessionStorage.getItem("rodentlab-uk-localization-v2") === "done") return;
    } catch (error) {}

    document.cookie = "cart_currency=" + targetCurrency + "; Max-Age=31536000; Path=/; Secure; SameSite=Lax";

    var formData = new FormData();
    formData.append("form_type", "localization");
    formData.append("utf8", "\u2713");
    formData.append("_method", "put");
    formData.append("country_code", targetCountry);

    fetch("/localization", {
      method: "POST",
      body: formData,
      credentials: "same-origin",
    })
      .then(function (response) {
        if (response.ok || response.redirected) {
          try {
            if (window.sessionStorage) sessionStorage.setItem("rodentlab-uk-localization-v2", "done");
          } catch (error) {}
          window.location.reload();
        }
      })
      .catch(function () {});
  }

  forceUkLocalization();

  function getCartRenderer() {
    return document.querySelector("cart-drawer") || document.querySelector("cart-notification");
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.toggleAttribute("aria-disabled", loading);
    button.classList.toggle("loading", loading);
  }

  function showFormError(form, message) {
    var wrapper = form.closest("product-form")?.querySelector(".product-form__error-message-wrapper");
    var target = wrapper?.querySelector(".product-form__error-message");
    if (!wrapper || !target) return;
    target.textContent = message || "Could not add this pack to cart. Please try again.";
    wrapper.hidden = false;
  }

  function ensureMetaPixel() {
    var pixelId = "1538720127169808";
    if (!window.fbq) {
      var fbq = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      window.fbq = fbq;
      window._fbq = fbq;
    }

    if (!window.__rodentlabMetaPixelLoaded) {
      window.__rodentlabMetaPixelLoaded = true;
      var script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      var firstScript = document.getElementsByTagName("script")[0];
      if (firstScript && firstScript.parentNode) firstScript.parentNode.insertBefore(script, firstScript);
    }

    if (!window.__rodentlabMetaPixelInited) {
      window.__rodentlabMetaPixelInited = true;
      window.fbq("init", pixelId);
    }

    return window.fbq;
  }

  function trackMetaAddToCart(item, form) {
    try {
      var variantInput = form.querySelector('[name="id"]');
      var quantityInput = form.querySelector('[name="quantity"]');
      var variantId = String(item.variant_id || item.id || variantInput?.value || "");
      if (!variantId) return;

      var quantity = Number(item.quantity || quantityInput?.value || 1);
      if (!Number.isFinite(quantity) || quantity < 1) quantity = 1;

      var cents = Number(item.final_line_price || item.line_price || 0);
      if (!cents && item.price) cents = Number(item.price) * quantity;
      var value = cents ? Math.round((cents / 100) * 100) / 100 : undefined;
      var eventId = "rluk-atc-" + variantId + "-" + Date.now() + "-" + Math.random().toString(16).slice(2);

      ensureMetaPixel()("track", "AddToCart", {
        content_ids: [variantId],
        content_type: "product",
        contents: [{ id: variantId, quantity: quantity }],
        currency: "GBP",
        value: value,
      }, { eventID: eventId });
    } catch (error) {}
  }

  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches('form[action*="/cart/add"]')) return;
      if (form.dataset.rodentlabFallbackSubmitting === "true") return;

      var productForm = form.closest("product-form");
      if (!productForm) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      var submitter = event.submitter || form.querySelector('[type="submit"]');
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        showFormError(form, "Please choose a pack before adding to cart.");
        return;
      }

      form.dataset.rodentlabFallbackSubmitting = "true";
      setButtonLoading(submitter, true);

      var cartRenderer = getCartRenderer();
      var formData = new FormData(form);
      var skipCart = variantInput.dataset.skipCart === "true";

      if (cartRenderer && typeof cartRenderer.getSectionsToRender === "function") {
        formData.append(
          "sections",
          cartRenderer
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            })
            .join(",")
        );
        formData.append("sections_url", window.location.pathname);
      }

      fetch(window.routes?.cart_add_url || "/cart/add", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: formData,
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status) {
            showFormError(form, data.description);
            return;
          }

          trackMetaAddToCart(data, form);

          if (skipCart) {
            window.location.href = "/checkout";
            return;
          }

          if (cartRenderer && typeof cartRenderer.renderContents === "function") {
            cartRenderer.renderContents(data);
            return;
          }

          window.location.href = window.routes?.cart_url || "/cart";
        })
        .catch(function () {
          showFormError(form);
        })
        .finally(function () {
          form.dataset.rodentlabFallbackSubmitting = "false";
          setButtonLoading(submitter, false);
        });
    },
    true
  );

  forceJapanLocalization();
})();
